import { Program } from './../constants/models/Program';
import {
  PROGRAM_MANAGER_ROUTE,
  PROGRAM_ROUTE,
  COUNSELOR_ROUTE,
  PARENT_ROUTE,
} from './../constants/routes';
import { User } from '../constants/models/User';
import API from './api';
import { Organisation } from '../constants/models/Organisation';

export async function getProgramManagerById(id: string) {
  try {
    const res = await API.get<{ data: User; success: boolean }>(
      `${PROGRAM_MANAGER_ROUTE}/${id}`
    );
    return res.data.data;
  } catch (err) {
    throw err;
  }
}
export async function getOrganisationById(id: string) {
  try {
    const res = await API.post<{ data: Organisation; success: boolean }>(
      `${PROGRAM_MANAGER_ROUTE}/getOrganisationById`,
      {
        id
      }
    );
    return res.data.data;
  } catch (err) {
    throw err;
  }
}
export async function getProgramManagerByOrgId(id: string) {
  try {
    const res = await API.post<{ data: []; success: boolean }>(
      `${PROGRAM_MANAGER_ROUTE}/getProgramManagerByOrgId`,
      {
        id
      }
    );
    return res.data.data;
  } catch (err) {
    throw err;
  }
}
export async function getOrganisationList() {
  try {
    const res = await API.post<{ data: []; success: boolean }>(
      `${PROGRAM_MANAGER_ROUTE}/getOrganisationList`
    );
    return res.data.data;
  } catch (err) {
    throw err;
  }
}


export async function getSearchOrganisationBySuperAdmin( 
  name: string,
  ) {
  try {
    const res = await API.post<{ data: []; success: boolean }>(
      `${PROGRAM_MANAGER_ROUTE}/getSearchOrganisationBySuperAdmin`,
      {
        name
      }
    );
    return res.data.data;
  } catch (err) {
    throw err;
  }
}

export async function searchParentByName( 
  name: string,
  ) {
  try {
    const res = await API.post<{ data: User[]; success: boolean }>(
      `${PARENT_ROUTE}/searchParentByName`,
      {
        name
      }
    );
    return res.data.data;
  } catch (err) {
    throw err;
  }
}
export async function getSearchOrganisationBySuperAdminorList( 
  name: string,
  ) {
  try {
    const res = await API.post<{ data: []; success: boolean }>(
      `${PROGRAM_MANAGER_ROUTE}/getSearchOrganisationBySuperAdminorList`,
      {
        name
      }
    );
    return res.data.data;
  } catch (err) {
    throw err;
  }
}

export async function getSearchSuperAdminListByUser( 
  name: string,
  ) {
  try {
    const res = await API.post<{ data: []; success: boolean }>(
      `${PROGRAM_MANAGER_ROUTE}/getSearchSuperAdminListByUser`,
      {
        name
      }
    );
    return res.data.data;
  } catch (err) {
    throw err;
  }
}
export async function getSearchOrganisationByName( 
  name: string,
  ) {
  try {
    const res = await API.post<{ data: []; success: boolean }>(
      `${PROGRAM_MANAGER_ROUTE}/getSearchOrganisationByName`,
      {
        name
      }
    );
    return res.data.data;
  } catch (err) {
    throw err;
  }
}

export async function getSearchOrganisationById( 
  id: string,
  ) {
  try {
    const res = await API.post<{ data: []; success: boolean }>(
      `${PROGRAM_MANAGER_ROUTE}/getSearchOrganisationById`,
      {
        id
      }
    );
    return res.data.data;
  } catch (err) {
    throw err;
  }
}
export async function getProgramManagerList() {
  try {
    const res = await API.post<{ data: []; success: boolean }>(
      `${PROGRAM_MANAGER_ROUTE}/getProgramManagerList`
    );
    return res.data.data;
  } catch (err) {
    throw err;
  }
}
export async function getSupportAdminList() {
  try {
    const res = await API.post<{ data: []; success: boolean }>(
      `${PROGRAM_MANAGER_ROUTE}/getSupportAdminList`
    );
    return res.data.data;
  } catch (err) {
    throw err;
  }
}
export async function createProgramManager(
  id: string,
  name: string,
  email: string,
  schoolName: string,
) {
  try {
    let text = email;
    email = text.toLowerCase();
    const res = await API.post<{ data: User; success: boolean }>(
      `${PROGRAM_MANAGER_ROUTE}`,
      {
        id,
        name,
        email,
        schoolName
      }
    );
    return res.data.data;
  } catch (err) {
    throw err;
  }
}
export async function getDeclineStatus(
  email: string,
) {
  try {
    const res = await API.post<{ data: string; success: boolean }>(
      `${PROGRAM_MANAGER_ROUTE}/getDeclineStatus`,
      {
        email:email,
        
      }
    );
    return res.data.data;
  } catch (err) {
    throw err;
  }
}
export async function getChkActiveStatus(
  email: string,
) {
  try {
    const res = await API.post<{ data:User; success: boolean }>(
      `${PROGRAM_MANAGER_ROUTE}/getChkActiveStatus`,
      {
        email:email,
        
      }
    );
    return res.data.data;
  } catch (err) {
    throw err;
  }
}
export async function declineOrganisation(
  id: string,
) {
  try {
    const res = await API.post<{ data: []; success: boolean }>(
      `${PROGRAM_MANAGER_ROUTE}/declineOrganisation`,
      {
        orgid:id,
        
      }
    );
    return res.data.data;
  } catch (err) {
    throw err;
  }
}

export async function approvedOrganisation(
  id: string,
) {
  try {
    const res = await API.post<{ data: []; success: boolean }>(
      `${PROGRAM_MANAGER_ROUTE}/approvedOrganisation`,
      {
        orgid:id,
        
      }
    );
    return res.data.data;
  } catch (err) {
    throw err;
  }
}
export async function changeProgramStatus(
  id: string,status: string,
) {
  try {
    const res = await API.post<{ data: []; success: boolean }>(
      `${PROGRAM_MANAGER_ROUTE}/changeProgramStatus`,
      {
        id:id,
        status:status
        
      }
    );
    return res.data.data;
  } catch (err) {
    throw err;
  }
}
export async function chkProgramStatus(
  id: string,status: string,programId: string,
) {
  try {
    const res = await API.post<{ data: []; success: boolean }>(
      `${PROGRAM_MANAGER_ROUTE}/chkProgramStatus`,
      {
        id:id,
        status:status,
        programId
        
      }
    );
    return res.data.data;
  } catch (err) {
    throw err;
  }
}
export async function createOrganisation(
  phoneno: string,
  name: string,
  email: string,
  programname: string,
  tellus: string,
  firstchk: boolean,
  countryCode: string,
) {
  try {
    let text = email;
            email = text.toLowerCase();
    const res = await API.post<{ data: []; success: boolean }>(
      `${PROGRAM_MANAGER_ROUTE}/creatEnquiry`,
      {
        phoneno,
        name,
        email,
        programname,
        tellus,
        firstchk,
        countryCode
      }
    );
    return res.data.data;
  } catch (err) {
    throw err;
  }
}

export async function createOrganisationBySuperAmin(
  phoneno: string,
  name: string,
  email: string,
  programname: string,
  tellus: string,
  firstchk: boolean,
) {
  try {
    let text = email;
            email = text.toLowerCase();
    const res = await API.post<{ data: []; success: boolean }>(
      `${PROGRAM_MANAGER_ROUTE}/creatOrganisationBySuperAdmin`,
      {
        phoneno,
        name,
        email,
        programname,
        tellus,
        firstchk
      }
    );
    return res.data.data;
  } catch (err) {
    throw err;
  }
}

export async function updateOrganisationBySuperAmin(
  firstname: string,
  lastname: string,
  tellus: string,
  phoneno: string,
  programMangerId: string,
 
) {
  try {
    const res = await API.post<{ data: []; success: boolean }>(
      `${PROGRAM_MANAGER_ROUTE}/updateOrganisationBySuperAmin`,
      {
        firstname,
        lastname,
        tellus,
        phoneno,
        programMangerId,
      
      }
    );
    return res.data.data;
  } catch (err) {
    throw err;
  }
}

export async function getProgramForProgramManager(programManagerId: string) {
  try {
    const res = await API.get<{ data: Program[]; success: boolean }>(
      `${PROGRAM_MANAGER_ROUTE}/${programManagerId}${PROGRAM_ROUTE}`
    );
    return res.data.data;
  } catch (err) {
    throw err;
  }
}

export async function getProgramForCounselor(counselorId: string) {
  try {
    const res = await API.get<{ data: Program[]; success: boolean }>(
      `${COUNSELOR_ROUTE}/${counselorId}${PROGRAM_ROUTE}`
    );
    return res.data.data;
  } catch (err) {
    throw err;
  }
}

export async function updateProgramManager(
  id: string,
  name: string,
  email: string,
  address: string,
  street: string,
  city: string,
  state: string,
  country: string,
  postalCode: number,
  // about: string,
  imageUrl: string | undefined
) {
  try {
    const res = await API.post<{ data: User; success: boolean }>(
      `${PROGRAM_MANAGER_ROUTE}/${id}/updateProgramManager`,
      {
        name,
        email,
        address,
        street,
        city,
        state,
        country,
        postalCode,
        // about,
        imageUrl: imageUrl ?? 'no-url',
      }
    );
    return res.data.data;
  } catch (err) {
    throw err;
  }
}

export async function createProgramManagerBySuperAdmin(
  id: string,
  name: string,
  email: string,
 
) {
  try {
    const res = await API.post<{ data: User; success: boolean }>(
      `${PROGRAM_MANAGER_ROUTE}/createProgramManagerBySuperAdmin`,
      {
        id,
        name,
        email,
       
      }
    );
    return res.data.data;
  } catch (err) {
    throw err;
  }
}
